import { useAccessToken } from "@/hooks";
import { authorizedGet } from "@/utils/request";
import useSWR from "swr";
import useSWRImmutable from "swr/immutable";
import type { QuestCompletion, QuestCompletions } from "./types";

export const useQuestCompletions = (
  gameId?: string,
  disableRevalidation = false,
) => {
  const getAccessToken = useAccessToken();

  const useSWRFn = disableRevalidation ? useSWRImmutable : useSWR;

  const {
    data: completedQuests,
    isLoading,
    mutate,
  } = useSWRFn<QuestCompletions>(
    gameId !== undefined ? `questCompletions${gameId}` : "no-game-id",
    async () => {
      const accessToken = await getAccessToken();
      if (!accessToken) {
        throw new Error("No access token");
      }
      const response = await authorizedGet<{
        result: QuestCompletion[];
      }>(
        `/v1/quests/quest-completions${gameId ? `?game_id=${gameId}` : ""}`,
        accessToken,
      );
      if (response.result) {
        return Object.fromEntries(
          response.result.map((completion) => [
            completion.external_id,
            completion,
          ]),
        );
      }
      return {};
    },
    {
      revalidateOnFocus: true,
    },
  );

  return {
    completedQuests,
    isLoading,
    mutate,
  };
};
